/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Demo_Unavailable_DescriptionInputs */



/**
* | output |
* | --- |
* | "In this demo you can practise: play out conversations and get feedback on them." |
*
* @param {Demo_Unavailable_DescriptionInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const demo_unavailable_description = /** @type {((inputs?: Demo_Unavailable_DescriptionInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demo_Unavailable_DescriptionInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("In deze demo kan je oefenen: gesprekken naspelen en er feedback op krijgen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dans cette démo, vous pouvez vous entraîner : jouer des conversations et recevoir du feedback.")
	return /** @type {LocalizedString} */ ("In this demo you can practise: play out conversations and get feedback on them.")
});